var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowitworks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 322,
    viewBox: "0 0 323 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4290_11429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.192 114.671V134.343C259.192 223.391 178.01 260.71 161.773 267.348C145.537 260.71 64.3544 223.31 64.3544 134.343V79.3763C81.4795 74.467 98.2432 68.381 114.525 61.162C130.808 54.1434 146.594 46.0294 161.773 36.8763C173.605 44.0762 185.828 50.6164 198.386 56.4667V54.1191C198.394 49.1232 199.022 44.1474 200.254 39.3048C188.561 33.6747 177.204 27.3769 166.238 20.4429L161.773 17.5286L157.389 20.362C141.625 30.2664 125.124 38.9536 108.03 46.3477C90.6273 54.0903 72.628 60.425 54.2066 65.2905L48.1179 66.8286V134.343C48.1179 242.738 157.958 283.295 159.013 283.7L161.773 284.671L164.533 283.7C165.67 283.7 275.428 242.819 275.428 134.343V112.405C270.144 113.888 264.682 114.65 259.192 114.671Z",
    fill: "#2F57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.191 94.4336C281.609 94.4336 299.783 76.3118 299.783 53.9574C299.783 31.603 281.609 13.4812 259.191 13.4812C236.774 13.4812 218.6 31.603 218.6 53.9574C218.6 76.3118 236.774 94.4336 259.191 94.4336Z",
    fill: "#2F57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.925 63.9572H248.592C248.592 67.5572 253.159 70.6239 258.592 70.6239C264.025 70.6239 268.592 67.5572 268.592 63.9572C268.592 60.2905 265.125 58.9572 257.792 57.1905C250.725 55.4239 241.925 53.2239 241.925 43.9572C241.925 37.9905 246.825 32.9239 253.592 31.2239V23.9572H263.592V31.2239C270.359 32.9239 275.259 37.9905 275.259 43.9572H268.592C268.592 40.3572 264.025 37.2905 258.592 37.2905C253.159 37.2905 248.592 40.3572 248.592 43.9572C248.592 47.6239 252.059 48.9572 259.392 50.7239C266.459 52.4905 275.259 54.6905 275.259 63.9572C275.259 69.9239 270.359 74.9905 263.592 76.6905V83.9572H253.592V76.6905C246.825 74.9905 241.925 69.9239 241.925 63.9572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.212 104.433L219.308 124.528L145.212 198.719L105.022 158.481L125.117 138.386L145.212 158.481L199.212 104.433ZM199.212 117.766L145.212 171.862L125.117 152.005L118.403 158.481L145.212 185.243L205.927 124.528L199.212 117.766Z",
    fill: "#2F57BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4290_11429",
    x: 0.710033,
    y: 0.40776,
    width: 322.125,
    height: 321.298,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.95633
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.46725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.701961 0 0 0 0 0.701961 0 0 0 0 0.701961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4290_11429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4290_11429",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowitworks);
export default __webpack_public_path__ + "static/media/howitworks.936400721861778cf99df0bfa7b265e4.svg";
export { ForwardRef as ReactComponent };